import {
  faArrowRight,
  faCalendar,
  faLock,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

import type { GuideListItem } from "../../shared/contracts";

export function DecisionCard({ decision }: { decision: GuideListItem }) {
  const target = `/guides/${decision.accountSlug}/${decision.code}`;
  return (
    <Link
      className="decision-card"
      to={target}
      aria-label={`View guide ${decision.code}: ${decision.title}`}
    >
      <span className="decision-id" aria-label={`Guide ${decision.code}`}>
        #{decision.code}
      </span>
      <div className="decision-card-body">
        <div className="decision-row-heading">
          <h2>{decision.title}</h2>
          <div className="eyebrow-row">
            <span>{decision.ownerName}</span>
            <span>
              {decision.visibility === "private" ? (
                <>
                  <FontAwesomeIcon icon={faLock} /> Private
                </>
              ) : (
                <>Public</>
              )}
            </span>
            <span>
              <FontAwesomeIcon icon={faCalendar} />{" "}
              {new Date(`${decision.guideDate}T12:00:00`).toLocaleDateString()}
            </span>
            {decision.isFollowing ? (
              <span>
                <FontAwesomeIcon icon={faStar} /> Following
              </span>
            ) : null}
            <span>
              {decision.itemCount.toLocaleString()} agenda item
              {decision.itemCount === 1 ? "" : "s"}
            </span>
            <span>
              {decision.adoptedCount.toLocaleString()} position
              {decision.adoptedCount === 1 ? "" : "s"} set
            </span>
            {decision.status !== "published" ? (
              <span>{decision.status}</span>
            ) : null}
          </div>
          <span className="row-view-link" aria-hidden="true">
            View <FontAwesomeIcon icon={faArrowRight} />
          </span>
        </div>
        <p>{decision.description}</p>
      </div>
    </Link>
  );
}
